import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, withCtx as _withCtx, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = (n: any) => (_pushScopeId("data-v-42b4186f"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "training-container" }
const _hoisted_2 = { class: "video-section__title" }
const _hoisted_3 = { class: "video-section__description" }
const _hoisted_4 = { class: "video-wrapper" }
const _hoisted_5 = ["src", "title"]

import { ref } from "vue";
import InnerPageLayout from "@/widgets/layouts/InnerPageLayout.vue";
import TopPanel from "@/widgets/sidebars/TopPanel.vue";
import BreadCrumbs from "@/shared/menu/BreadCrumbs.vue";


export default /*#__PURE__*/_defineComponent({
  __name: 'TrainingPage',
  setup(__props) {

const items = ref([{ label: "Обучение" }]);

const videos = [
  {
    title: "CDP. Инструкция для клиентов",
    description:
      "Обзор платформы: вход в систему, навигация и основные возможности (сегменты, кампании, дашборды).",
    src: "https://player.vimeo.com/video/1192581235?title=0&byline=0&portrait=0&badge=0&autopause=0&player_id=0&app_id=58479",
  },
  {
    title: "Аналитический отчёт клиента (Конкурентный анализ)",
    description:
      "Как работать с аналитическим отчётом: фильтры, таблицы и графики.",
    src: "https://player.vimeo.com/video/1192565497?title=0&byline=0&portrait=0&badge=0&autopause=0&player_id=0&app_id=58479",
  },
  {
    title: "Отчет Sales Lift",
    description: "Как работать с отчетом Sales Lift.",
    src: "https://player.vimeo.com/video/1195893631?title=0&byline=0&portrait=0&badge=0&autopause=0&player_id=0&app_id=58479",
  },
];

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(InnerPageLayout, null, {
    default: _withCtx(() => [
      _createVNode(TopPanel, null, {
        default: _withCtx(() => [
          _createVNode(BreadCrumbs, {
            items: items.value,
            class: "s-bread"
          }, null, 8, ["items"])
        ]),
        _: 1
      }),
      _createElementVNode("div", _hoisted_1, [
        (_openBlock(), _createElementBlock(_Fragment, null, _renderList(videos, (video) => {
          return _createElementVNode("section", {
            key: video.src,
            class: "video-section"
          }, [
            _createElementVNode("h2", _hoisted_2, _toDisplayString(video.title), 1),
            _createElementVNode("p", _hoisted_3, _toDisplayString(video.description), 1),
            _createElementVNode("div", _hoisted_4, [
              _createElementVNode("iframe", {
                src: video.src,
                frameborder: "0",
                allow: "autoplay; fullscreen; picture-in-picture; clipboard-write; encrypted-media; web-share",
                referrerpolicy: "strict-origin-when-cross-origin",
                title: video.title
              }, null, 8, _hoisted_5)
            ])
          ])
        }), 64))
      ])
    ]),
    _: 1
  }))
}
}

})